import initI18n from './i18n';

/**
 * Initializes the coaching-ui package (i18n).
 */
export default function init(): void {
  initI18n();
}
